
export const NSWLogoAltText = "Beachwatch NSW";

export const NoSwellDataText = "Not available"
export const NoWindDataText = "Not available"

export enum PollutionForecastTypes {
    POLLUTION_LIKELY = "Likely",
    POLLUTION_UNLIKELY = "Unlikely",
    POLLUTION_POSSIBLE = "Possible",
    DATA_UNAVAILABLE = "Forecast temporarily unavailable"
}

export const AnnualGradeIconsPath = "assets/images/AnnualGradeIcons/";
export const AnnualGrades = Object.freeze(
    {
        NOT_AVAILABLE : { code : 0, description : "Not available", colour : "#FFFFFF", starRatingLargeIcon : `${AnnualGradeIconsPath}Notavailable.svg`, starRatingSmallIcon : `${AnnualGradeIconsPath}Notavailable.svg`, icon : `${AnnualGradeIconsPath}Notavailable.svg` },
        VERY_POOR : { code : 1, description : "Very Poor", colour : "#DF4461", starRatingLargeIcon : `${AnnualGradeIconsPath}Red-Large.svg`, starRatingSmallIcon : `${AnnualGradeIconsPath}Red-Small.svg`, icon : `${AnnualGradeIconsPath}Red.svg` },
        POOR : { code : 2, description : "Poor", colour : "#F58249", starRatingLargeIcon : `${AnnualGradeIconsPath}Orange-Large.svg`, starRatingSmallIcon : `${AnnualGradeIconsPath}Orange-Small.svg`, icon : `${AnnualGradeIconsPath}Orange.svg` },
        FAIR : { code : 3, description : "Fair", colour : "#FAAF05" , starRatingLargeIcon : `${AnnualGradeIconsPath}Yellow.svg`, starRatingSmallIcon : `${AnnualGradeIconsPath}Yellow-Small.svg`, icon : `${AnnualGradeIconsPath}Yellow.svg` },
        GOOD : { code : 4, description : "Good", colour : "#BDE36E", starRatingLargeIcon : `${AnnualGradeIconsPath}Lightgreen-Large.svg`, starRatingSmallIcon : `${AnnualGradeIconsPath}Lightgreen-Small.svg`, icon : `${AnnualGradeIconsPath}Lightgreen.svg` },
        VERY_GOOD : { code : 5, description : "Very Good", colour : "#33BB6A", starRatingLargeIcon : `${AnnualGradeIconsPath}Darkgreen-Large.svg`, starRatingSmallIcon : `${AnnualGradeIconsPath}Darkgreen-Small.svg`, icon : `${AnnualGradeIconsPath}Darkgreen.svg` },
        FOLLOW_UP : { code : 6, description : "Follow up", colour : "#FFFFFF", starRatingLargeIcon : `${AnnualGradeIconsPath}Notavailable.svg`, starRatingSmallIcon : `${AnnualGradeIconsPath}Notavailable.svg`, icon : `${AnnualGradeIconsPath}Notavailable.svg` },
       
    }
);

export const AnnualGradeIcons = new Map([
    [AnnualGrades.FOLLOW_UP.description, `${AnnualGradeIconsPath}Notavailable.svg`],
    [AnnualGrades.NOT_AVAILABLE.description, `${AnnualGradeIconsPath}Notavailable.svg`],
    [AnnualGrades.VERY_GOOD.description, `${AnnualGradeIconsPath}Darkgreen.svg`],
    [AnnualGrades.GOOD.description, `${AnnualGradeIconsPath}Lightgreen.svg`],
    [AnnualGrades.FAIR.description, `${AnnualGradeIconsPath}Yellow.svg`],
    [AnnualGrades.POOR.description, `${AnnualGradeIconsPath}Orange.svg`],
    [AnnualGrades.VERY_POOR.description, `${AnnualGradeIconsPath}Red.svg`]
]);

export const LatestResultIconsDesktop = new Map([
    ["Good", "Darkgreen-Large.svg"],
    ["Ok", "Lightgreen-Large.svg"],
    ["Poor", "Orange-Large.svg"],
    ["Bad", "Red-Large.svg"]
]);

export const LatestResultIconsBlue = new Map([
    ["Good", "Star-Rating-Blue-Good.svg"],
    ["Ok", "Star-Rating-Blue-Fair.svg"],
    ["Poor", "Star-Rating-Blue-Poor.svg"],
    ["Bad", "Star-Rating-Blue-Bad.svg"]
]);

export const LatestResultIconsMobile = new Map([
    ["Good", "Darkgreen-Small.svg"],
    ["Ok", "Lightgreen-Small.svg"],
    ["Poor", "Orange-Small.svg"],
    ["Bad", "Red-Small.svg"]
]);

export const WeatherForecastIcons = new Map([
    [1, "sunny.svg"],    
    [2, "clear.svg"],
    [3, "partly cloudy (day).svg"],
    [4, "cloudy.svg"],
    [6, "hazy.svg"],
    [8, "light rain (day).svg"],
    [9, "windy.svg"],
    [10, "fog.svg"],
    [11, "showers.svg"],
    [12, "rain.svg"],
    [13, "dusty.svg"],    
    [14, "frost.svg"],
    [15, "snow.svg"],
    [16, "storm.svg"],
    [17, "light rain (day).svg"],
    [18, "heavy shower.svg"],   
    [19, "cyclone.svg"]
    // ["Swell", "swell.svg"],
    // ["Tide", "tide.svg"]   
]);

export const AmenitiesIconsMap = new Map([
    ["Toilets", "wc.svg"],
    ["Showers", "shower.svg"],
    ["Baby changing facilities", "baby_changing_station.svg"],
    ["Parking", "local_parking.svg"],
    ["Bus", "departure_board.svg"],
    ["Shade", "deck_shade.svg"],
    ["BBQ", "outdoor_grill.svg"],
    ["Cafe / Kiosk", "storefront.svg"],
    ["Playground / Park", "nature.svg"]
]);

export const WindDirectionIconsMap = new Map([
    ["EAST", "assets/images/SiteDetails/WindDirection/West.svg"],
    ["E", "assets/images/SiteDetails/WindDirection/West.svg"],

    ["WEST", "assets/images/SiteDetails/WindDirection/East.svg"],
    ["W", "assets/images/SiteDetails/WindDirection/East.svg"],

    ["SOUTH", "assets/images/SiteDetails/WindDirection/North.svg"],
    ["S", "assets/images/SiteDetails/WindDirection/North.svg"],

    ["NORTH", "assets/images/SiteDetails/WindDirection/South.svg"],
    ["N", "assets/images/SiteDetails/WindDirection/South.svg"],

    ["NW", "assets/images/SiteDetails/WindDirection/South-East.svg"],
    ["NNW", "assets/images/SiteDetails/WindDirection/South-East.svg"],
    ["WNW", "assets/images/SiteDetails/WindDirection/South-East.svg"],

    ["NE", "assets/images/SiteDetails/WindDirection/South-West.svg"],
    ["NNE", "assets/images/SiteDetails/WindDirection/South-West.svg"],
    ["ENE", "assets/images/SiteDetails/WindDirection/South-West.svg"],

    ["SW", "assets/images/SiteDetails/WindDirection/North-East.svg"],
    ["SSW", "assets/images/SiteDetails/WindDirection/North-East.svg"],
    ["WSW", "assets/images/SiteDetails/WindDirection/North-East.svg"],

    ["SE", "assets/images/SiteDetails/WindDirection/North-West.svg"],
    ["SSE", "assets/images/SiteDetails/WindDirection/North-West.svg"],
    ["ESE", "assets/images/SiteDetails/WindDirection/North-West.svg"]    
]);


export const PollutionForecastBoxColours : {[key : string] : any } = {
    [PollutionForecastTypes.POLLUTION_LIKELY] :   { boxBackgroundColor : "#FFE6EA", titleBlockBackgroundColor : "#D7153A", titleBlockTextColor : "#FFFFFF", icon : "Red.svg" },
    [PollutionForecastTypes.POLLUTION_UNLIKELY] : { boxBackgroundColor : "#DBFADF", titleBlockBackgroundColor : "#00AA45", titleBlockTextColor : "#22272B", icon : "Green.svg" },
    [PollutionForecastTypes.POLLUTION_POSSIBLE] : { boxBackgroundColor : "#FDE79A", titleBlockBackgroundColor : "#FAAF05", titleBlockTextColor : "#22272B", icon : "Yellow.svg" },
    [PollutionForecastTypes.DATA_UNAVAILABLE] : { boxBackgroundColor : "#CBEDFD", titleBlockBackgroundColor : "#146CFD", titleBlockTextColor : "#FFFFFF", icon : "Unavailable.svg" }
}



export const MAP_BOUNDS_CHANGED_INTERVAL = 250; // in seconds

export const NSWMapBounds = {
    north: -28.1570082,
    south: -37.505063,
    west: 140.9992862,
    east: 153.6387228
};

export const FORMAT_DATE_LOCALE = "en-AU";
export const DOWNLOAD_DATA_DATE_FORMAT = "dd/MM/YYYY";

export const FAVOURITES_COOKIE_SEPARATOR = "||";
export const FAVOURITES_COOKIE_NAME = "beachwatchFavourites";
export const FAVOURITES_COOKIE_EXPIRY_DAYS = 365;
export const ANNUALGRADE_HISTORY_INTERVAL_YEARS = 10; // last 5 years
export const SITESLIST_REFRESH_INTERVAL_SECONDS = 5 * 60 * 1000; // 5 minutes converted to milliseconds

/* Chart constants */
export const CHART_DATE_FORMAT = "dd/MMM/YY";
export const CHART_TOOLTIP_ENTEROCOCCI_UNITS = "cfu/100mL";
export const TRENDS_TABLE_DATE_FORMAT = "dd/MM/YY";
export const CHART_TOOLTIP_DATE_FORMAT = "dd MMM YYYY";
export const TREND_GRAPH_CHART_ANNUAL_DATE_FORMAT = "dd/MM/YYYY";
export const TREND_EXPORT_DATA_DATE_FORMAT = "dd/MM/YYYY";

export const CHART_TOOLTIP_RAINFALL_UNITS = "mm";
export const CHART_TOOLTIP_WATERTEMP_UNITS = "°C"; // "&#xB0;C";

export const MARKER_ICON_SIZE = { ICON_WIDTH  : 32, ICON_HEIGHT  : 32 };

export const REGEX_DECIMAL = "^-?([0]{1}\.{1}[0-9]+|[1-9]{1}[0-9]*\.{1}[0-9]+|[0-9]+|0)";

export const RESPONSIVE_DESKTOP_BREAKPOINT = "(min-width: 992px)";
export const RESPONSIVE_MOBILE_BREAKPOINT = "(max-width: 991px)";

export const AboutBeachwatchVideoCaption = "Watch how Beachwatch monitors water quality for swimming.";

export const ForecastNotAvailableDesc = "Forecast not available";

export const DEEP_BLUE_HEX_COLOUR = "#002664"; // export this from scss file and importing in ts file not working

export const DOWNLOAD_DATA_ENTEROCOCCI_COLUMNNAME = "Enterococci (cfu/100mL)";
export const DOWNLOAD_DATA_WATERTEMP_COLUMNNAME = "Water temperature (°C)";
export const DOWNLOAD_DATA_CONDUCTIVITY_COLUMNNAME = "Conductivity (µS/cm)";
export const DOWNLOAD_DATA_LATITUDE_COLUMNNAME = "Latitude";
export const DOWNLOAD_DATA_LONGITUDE_COLUMNNAME = "Longitude";
export const DOWNLOAD_DATA_COORDINATES_COLUMNNAME = "Coordinates";
export const DOWNLOAD_DATA_DATE_COLUMNNAME = "Date";
export const DOWNLOAD_DATA_TIME_COLUMNNAME = "Time";
